export default __webpack_public_path__ + "static/IBMPlexSans-SemiBold-Cyrillic-6d9b6411704ee0e26f3117ec701856e2.woff2";